import { AnalysisHistoryRecord } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function patch(analysisHistoryRecord: AnalysisHistoryRecord) {
  return DesignService.patch('analysisHistory', { data: analysisHistoryRecord });
}

export function bulkLoad(componentDesignGuids: readonly string[]) {
  return DesignService.post<readonly AnalysisHistoryRecord[]>('analysisHistory/bulkLoad', {
    data: componentDesignGuids,
  });
}
